/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { ContactCardComponentDisplay } from "cms/components/components/contact-card/display";
import { ContactCardComponentEditor } from "cms/components/components/contact-card/edit";

const ContactCardComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <ContactCardComponentDisplay />,
        editComponent: <ContactCardComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

ContactCardComponent.displayName = "ContactCardComponent";
export { ContactCardComponent };
